import { createContext, useContext } from 'react';

const AuthValidation = createContext(null);

const usePreLoaderData = <T = unknown>() => {
  const preLoaderData = useContext(AuthValidation);
  return preLoaderData as T;
};

export { AuthValidation, usePreLoaderData };
